/*
    アラートコンポーネント
    画面下から通知を行う
*/
import AlertMu from "@mui/material/Alert";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { removeIndexAlert, removeTimeTrigger } from "../../redux/alertSlice";
import { AlertColor } from "@mui/material/Alert";
import "./Alert.css";

// 定期実行処理
export default function useWatch(interval: number, callback: Function) {
  const [time, updateTime] = useState(Date.now());
  useEffect(() => {
    const timeoutId = setTimeout(() => updateTime(Date.now()), interval);
    callback();
    return () => {
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

  return time;
}

export const Alert: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const alertList = useSelector((state: RootState) => state.alert.alertList);

  // stateから指定時間超過したアラートを取り除く処理を定期実行する
  const time = useWatch(3000, () => {
    dispatch(removeTimeTrigger(time));
  });

  // アラートの背景色
  const getBgColor = (severity: AlertColor) => {
    if (severity === "info") {
      return "#4AB1CC";
    } else if (severity === "error") {
      return "#FF3366";
    } else if (severity === "warning") {
      return "#F9C748";
    }
    if (severity === "success") {
      return "#49BEAA";
    }
  };
  // アラートの文字色
  const getColor = (severity: AlertColor) => {
    if (severity === "info") {
      return "#FFFFFF";
    } else if (severity === "error") {
      return "#FFFFFF";
    } else if (severity === "warning") {
      return "#000000";
    }
    if (severity === "success") {
      return "#FFFFFF";
    }
  };

  const alertElements = alertList.map((d, index) => {
    return (
      <AlertMu
        variant="filled"
        className="fadeUp fade-out"
        severity={d.severity}
        sx={{ color: getColor(d.severity), bgcolor: getBgColor(d.severity) }}
        onClose={() => {
          dispatch(removeIndexAlert(index));
        }}
      >
        {d.message}
      </AlertMu>
    );
  });

  if (alertList.length > 0) {
    return <div className="alert-container">{alertElements}</div>;
  } else {
    return <></>;
  }
};
